import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { ifDefined as l } from '../../../../node_modules/lit-html/directives/if-defined.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z$1 from '../../atoms/buttons/generic-button/styles/secondary-button.scss.js';
import { searchService } from '../../utilities/backend-helpers/index.js';
import '../../atoms/buttons/enums.js';
import { getLang, isRTL } from '../../utilities/dom-helpers/index.js';
import '../content-card/index.js';
import '../load-more-button/index.js';
import { SearchResultType } from './enums.js';
import css_248z from './search-results.scss.js';

const pageSizeMap = {
    pages: 12,
    products: 18,
    productsalt: 18,
    blogs: 12,
    pressReleases: 1000,
};
const endpointMap = {
    products: '/api/productsearchservice/search/',
    productsalt: '/api/productsearchservice/search/',
    pages: '/api/contentsearchservice/search/',
    blogs: '/api/blogpostsservice/list/',
};
const renderBlogLabel = (labels) => labels === null || labels === void 0 ? void 0 : labels.map((label) => $ `<p slot="tags">${label}</p>`);
const renderBlogDate = (date) => date && $ `<p slot="date">${date}</p>`;
class SearchResults extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.currentPage = 1;
    }
    loadMore() {
        var _a;
        const language = (_a = getLang()) !== null && _a !== void 0 ? _a : 'en-us';
        const itemsPerPage = this.renderPerPage || pageSizeMap[this.type];
        searchService(endpointMap[this.type], this.term, itemsPerPage, this.currentPage * itemsPerPage, language)
            .then(r => r.json())
            .then(data => {
            this.results = [...this.results, ...data.items];
            this.currentPage += 1;
            this.requestUpdate();
        });
    }
    renderResults(type) {
        if (!this.results)
            this.results = this.data.items;
        switch (type) {
            case SearchResultType.PAGES:
                return this.results.map(result => $ `<div class="item-page"><p class="title"><a class="title-link" href="${result.url}">${o(result.title)}</a></p><div class="breadcrumb">${o(result.breadcrumbPath)}</div><div class="summary">${o(result.summary)}</div></div>`);
            case SearchResultType.PRODUCTS:
                return this.results.map(result => $ `<div class="item-product"><content-card isInSearch url="${result.url}" ?abbreviated="${true}" ?responsive="${false}" ?clickable="${true}" ctaText="${l(result.linkText)}"><img slot="image" src="${l(result.image)}" alt="${result.title} poster"><p slot="heading">${o(result.title)}</p></content-card></div>`);
            case SearchResultType.PRODUCTS_ALT:
                return this.results.map(result => $ `<div class="item-product"><content-card url="${result.url}" ?abbreviated="${true}" ?responsive="${false}" ?clickable="${true}" ctaText="${l(result.linkText)}"><img slot="image" src="${l(result.image)}" alt="${result.title} poster"><p slot="heading">${o(result.title)}</p></content-card></div>`);
            case SearchResultType.BLOGS:
                return this.results.map(result => {
                    var _a;
                    return $ `<div class="item-blog"><category-tile-small backgroundImage="${l(result.imageUrl)}" styleType="light" href="${result.url}" ctaText="${l(result.linkText)}">${result.date && renderBlogDate(result.date)} ${((_a = result.labels) === null || _a === void 0 ? void 0 : _a.length) && renderBlogLabel(result.labels)}<p slot="heading" class="card-heading">${o(result.headline)}</p><p slot="text" class="card-text">${o(result.body)}</p></category-tile-small></div>`;
                });
            default:
                return null;
        }
    }
    isMoreItems() {
        const itemsPerPage = this.renderPerPage || pageSizeMap[this.type];
        return this.total - this.currentPage * itemsPerPage > 0;
    }
    renderLoadMoreButton() {
        return this.isMoreItems()
            ? $ `<load-more-button text="${this.loadMoreText}" .onClickHandler="${() => this.loadMore()}"></load-more-button>`
            : null;
    }
    render() {
        return $ `<div class="search-results ${this.type} ${this.rtl || isRTL() ? 'rtl' : ''}">${this.renderResults(this.type)}</div>${this.renderLoadMoreButton()}`;
    }
}
SearchResults.styles = [css_248z, css_248z$1];
__decorate([
    e()
], SearchResults.prototype, "type", void 0);
__decorate([
    e({ type: Object })
], SearchResults.prototype, "data", void 0);
__decorate([
    e({ type: String })
], SearchResults.prototype, "term", void 0);
__decorate([
    e({ type: Number })
], SearchResults.prototype, "total", void 0);
__decorate([
    e({ type: Number })
], SearchResults.prototype, "renderPerPage", void 0);
__decorate([
    e({ type: String })
], SearchResults.prototype, "loadMoreText", void 0);
__decorate([
    e({ type: Boolean })
], SearchResults.prototype, "rtl", void 0);
__decorate([
    t()
], SearchResults.prototype, "results", void 0);
customElements.define('search-results', SearchResults);

export { SearchResults };
